module.exports = __webpack_public_path__ + "img/鄭順安.43b21016.jpg";